/** What a public link visitor may see and do. Mirrors the backend `PublicLinkCapabilitiesDto`. */
export interface PublicLinkCapabilities {
  /** Devices, widgets and scenes (read). */
  canViewDevices: boolean;
  /** Sending device commands. Requires `canViewDevices`. */
  canControlDevices: boolean;
  /** Starting scenes. Requires `canControlDevices`. */
  canStartScenes: boolean;
  /** Calendar events (read-only). */
  canViewEvents: boolean;
  /** Tickets (read-only). */
  canViewTickets: boolean;
  /** Interior designer templates. */
  canViewInteriorTemplates: boolean;
}

export type PublicLinkCapability = keyof PublicLinkCapabilities;

export const EMPTY_PUBLIC_LINK_CAPABILITIES: Readonly<PublicLinkCapabilities> = Object.freeze({
  canViewDevices: false,
  canControlDevices: false,
  canStartScenes: false,
  canViewEvents: false,
  canViewTickets: false,
  canViewInteriorTemplates: false
});

/**
 * Today's rules for a legacy (`public/:publicBase`) link, expressed as capabilities so feature code asks one
 * question for both link kinds: devices and scenes visible but not controllable, no Tasks, no Events, interior
 * templates only when the link carries an `interior` config.
 */
export function legacyPublicLinkCapabilities(hasInteriorConfig: boolean): PublicLinkCapabilities {
  return {
    canViewDevices: true,
    canControlDevices: false,
    canStartScenes: false,
    canViewEvents: false,
    canViewTickets: false,
    canViewInteriorTemplates: hasInteriorConfig
  };
}
